import { FunctionComponent } from 'react';
import BlueprintIcon from '../../../../BlueprintIcon';
import getDurationString from '../../../../../services/getDurationString';
import styles from '../../styles.module.scss';
import { PublicBasicOccurrence, PublicChildOccurrence } from '@cademy-package/sdk-component-types';

type OccurrenceExtrasProps = {
    occurrence: PublicBasicOccurrence;
    isChild: boolean;
    isBlock: boolean;
    childOccurrences?: Array<PublicChildOccurrence>;
    open: boolean;
    setOpen: (newValue: boolean) => void;
};

export const OccurrenceExtras: FunctionComponent<OccurrenceExtrasProps> = ({
    occurrence,
    isChild = false,
    isBlock,
    childOccurrences,
    open,
    setOpen,
}) => {
    if (isChild && !occurrence.individually_bookable) {
        return (
            <span className={styles.extras}>
                {`One of ${childOccurrences?.length || 'a number of'} dates`}
            </span>
        );
    }

    if (occurrence.available_spaces === 0) {
        return <span className={styles.extras}>No spaces left</span>;
    }

    if (occurrence.available_spaces) {
        return (
            <span className={styles.extras}>
                {`${occurrence.available_spaces} space${occurrence.available_spaces > 1 ? 's' : ''} left`}
            </span>
        );
    }

    if (!isBlock || !childOccurrences || childOccurrences.length === 0) {
        return null;
    }

    return (
        <button className={styles.showBlockDates} onClick={() => setOpen(!open)}>
            <BlueprintIcon icon={open ? 'ChevronDown' : 'ChevronRight'} width={12} height={12} />
            {`${childOccurrences.length} dates over ${getDurationString(childOccurrences[childOccurrences.length - 1].end_datetime - childOccurrences[0].start_datetime)}`}
        </button>
    );
};
